// Marca visible del entorno de pruebas. Solo se pinta cuando el build define
// VITE_ENV_LABEL (en producción va vacío, así que nunca aparece).
export const EnvBadge = () => {
  const label = import.meta.env.VITE_ENV_LABEL;

  if (!label) return null;

  return (
    <div
      data-testid="env-badge"
      className="fixed bottom-4 right-4 z-[9999] rounded-md bg-amber-500 px-3 py-1 text-xs font-semibold text-white shadow-lg"
    >
      {label}
    </div>
  );
};
